import React from 'react'
import { Box } from '@mui/material'
import Modal from 'src/components/Modal'
import * as S from '../Adjustments.styles'

interface AdjustmentDialogProps {
  open: boolean
  title: string
  onClose: () => void
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  error?: string
  confirmText?: string
  children: React.ReactNode
}

export const AdjustmentDialog = ({
  open,
  title,
  onClose,
  onSubmit,
  error,
  confirmText = 'Confirmar',
  children,
}: AdjustmentDialogProps) => (
  <Modal
    show={open}
    title={title}
    centered
    closeButtonAction={onClose}
    onHide={onClose}
    body={(
      <Box
        component='form'
        onSubmit={onSubmit}
        sx={{
          display: 'flex', flexDirection: 'column', gap: '1.5rem', padding: '1.5rem',
        }}
      >
        {children}
        {error && <S.ErrorSummary>{error}</S.ErrorSummary>}
        <S.CustomButton
          title={confirmText}
          type='submit'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
        />
      </Box>
    )}
  />
)
